<template>
  <div class="x-button">
    <div class="x-icon" />
    Follow us
  </div>
</template>
<script>
export default {
  props: {
  },
  setup() {
    
  },
}
</script>
<style lang="scss" scoped>
  .x-button {
    font-family: 'YoungSerif-Regular';
    width: 180px;
    height: 50px;
    text-align: center;
    background-color: transparent;
    border: 1px solid $black;
    color: $textBlack;
    font-size: 16px;
    border-radius: $controlRadius;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    letter-spacing: 0.3px;
    
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: $black;
      opacity: 0;
      z-index: -1;
      transition: opacity 0.3s ease;
    }
    
    .x-icon {
      width: 16px;
      height: 16px;
      background-repeat: no-repeat;
      background-image: url("~@/assets/icons/x.svg");
      background-size: contain;
      background-position: center;
      margin-right: 8px;
      transition: transform 0.3s ease;
    }

    &:hover {
      color: white;
      border-color: $black;
      
      &:after {
        opacity: 1;
      }
      
      .x-icon {
        transform: rotate(360deg);
        filter: brightness(0) invert(1);
      }
    }
  }

  @media (max-width: $tabletSize) {
    .x-button {
      height: 46px;
      width: 160px;
      font-size: 15px;
      
      .x-icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
    }
  }
</style>